// extracted by mini-css-extract-plugin
export default {"layout":"KSjUh4GhWxaLniZGySEa","fade-in":"qXC0H2nWyRms8rsoAZzV"};